if (typeof ProductFeatures !== "function") {

  class ProductFeatures extends HTMLElement {
    constructor() {
      super();
    }
    
    connectedCallback() {
      this.setupVariantListener();
    }

    setupVariantListener() {
        document.addEventListener('variant:change', (event) => {
          const sectionId = this.getAttribute('data-section-id');
          const productHandle = this.getAttribute('data-product-handle');
          const variantId = event.detail.variant ? event.detail.variant.id : null;
          const url = '/products/' + productHandle + '?variant=' + variantId + '&section_id=' + sectionId;
          
          fetch(url)
            .then(response => response.text())
            .then(html => {
              const parser = new DOMParser();
              const doc = parser.parseFromString(html, 'text/html');
              const section = doc.querySelector('#shopify-section-' + sectionId);
              const checkVariants = section.querySelector('product-variant-change');

              if (section) {
                this.innerHTML = checkVariants.innerHTML;
              }
            })
            .catch(error => console.error('Error loading updated section:', error));
        });
    }
  }

  if (typeof customElements.get("product-variant-change") == "undefined") {
		customElements.define("product-variant-change", ProductFeatures);
	}
}

